<template>
  <el-container>
    <el-header height="50">
      <div class="navbar clearfix">
        <div style="text-align: right;padding:6px 10px;">
          <el-button size="medium" @click="addCusTemp" plain type="primary" icon="el-icon-star-off">收藏已编辑内容</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button :loading="saveloading" size="medium" type="primary" @click="save" icon="el-icon-box">保存</el-button>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside width="500px">
        <div class="sidebar">
          <div class="left-tab pull-left">
            <div class="left-tab-item"
              v-for="(item, index) in types"
              :key="index"
              :class="item.active"
            >
              <router-link :to="{path: item.sidetype, query:{...query}}">
                <i :class="item.icon"></i><br />{{item.name}}
              </router-link>
            </div>
          </div>
          <div class="right-content pull-left">
            <template v-if="activeSideType=='temp'">
              <div class="menu-list clearfix">
                <a href="javascript:;"
                  :class="'menu-list-item '+(activeTag===index?'active':'')"
                  @click="checktype(index, item.id, item.parent_id)"
                  v-for="(item, index) in tags"
                  :key="index"
                >{{item.name}}
                
                  <ul class="menu-child">
                    <li v-for="(item2, index2) in item.childrenTags"
                        :key="index+'_'+index2">
                      <a href="javascript:;"
                        class="menu-list-item"
                        @click.stop="checktype(index, item2.id, item2.parent_id)"
                      >{{item2.name}}</a>
                    </li>
                  </ul>
                </a>
              </div>
              
              <div ref="tempBox" v-infinite-scroll="getTemps" class="temp-list" :style="{height: mainHeight-60+'px', marginTop:'20px'}">
                <template v-if="temps.length>0">
                <div
                  v-for="(item, index) in temps"
                  :key="index"
                >
                  <div class="temp-list-item"
                    @click="selectTemp(index)"
                    v-html="item.content"
                  ></div>
                  <div :data-index="index" v-show="item.contextmenuVisited" class="contextmenu-box">
                    <el-button @click="oncollection(item.id)" icon="el-icon-star-off">收藏</el-button>
                  </div>
                </div>
                </template>
                <div v-else-if="!tempLoading" class="temp-text text-center" style="text-align: center; padding:30px 0;">暂无相关数据</div>
                <div v-if="tempLoading" class="temp-text loading text-center"><i class="el-icon-loading"></i></div>
              </div>
            </template>
            <div v-if="activeSideType=='collection'">
              
              <div style="margin:0 15px;"> 
                <!-- 收藏分组 -->
                <div v-if="groupLoading" class="loading text-center temp-text"><i class="el-icon-loading"></i></div>
                <el-tabs v-else v-model="collGroup" @tab-click="collClick">
                  <el-tab-pane
                    v-for="(item, index) in groups"
                    :key="index"
                    :label="item.name"
                    :name="String(item.id)">
                    {{item.name}}
                  </el-tab-pane>
                </el-tabs>
              </div>
              
              <div class="temp-list" :style="{height: mainHeight-60+'px', marginTop:'20px'}">
                <template v-if="collList.length>0">
                <div
                  v-for="(item, index) in collList"
                  :key="index"
                  style="position: relative;"
                  class="temp-list-item"
                >
                  <div
                    @click="selectTemp(index, 'collList')"
                    v-html="item.content"
                  ></div>
                  <div class="coll-name">{{item.name}}</div>
                  <div class="dele_collection" @click="dele_collection(item.collect_id)">
                    <el-button size="mini" type="text" icon="el-icon-close" circle></el-button>
                  </div>
                </div>
                </template>
                <div v-else-if="!tempLoading" class="temp-text" style="text-align: center; padding:30px 0;">暂无相关数据</div>
                <div v-if="tempLoading" class="temp-text loading text-center"><i class="el-icon-loading"></i></div>
              </div>
              
            </div>
            <div v-if="activeSideType=='shear'"></div>
            <div v-if="activeSideType=='whole'">
              <div style="margin: 10px;">
                <el-input
                  placeholder="请输入搜索的内容"
                  v-model="wholeTmpName">
                  <i slot="suffix" @click="getTemps2('event')" class="el-input__icon el-icon-search"></i>
                </el-input>
              </div>
              
              <div ref="tempBox2" :infinite-scroll-disabled="disabled2" v-infinite-scroll="getTemps2" class="temp-list" :style="{height: mainHeight-60+'px', marginTop:'0'}">
                <template v-if="temps2.length>0">
                <el-row :gutter="15">
                  <el-col
                    :span="12"
                    v-for="(item, index) in temps2"
                    :key="index"
                  >
                    <div @click="selectTemp(index, 'temps2')">
                      <el-card shadow="hover" :body-style="{ padding: '0px' }">
                        <el-image
                              style="width:100%"
                              :src="item.thumb_uri"
                              :fit="cover"></el-image>
                        <div style="padding: 14px;">
                          <span>{{item.name}}</span>
                        </div>
                      </el-card>
                    </div>
                    <div :data-index="index" v-show="item.contextmenuVisited" class="contextmenu-box">
                      <el-button @click="oncollection(item.id)" icon="el-icon-star-off">收藏</el-button>
                    </div>
                  </el-col>
                </el-row>
                </template>
                <div v-else-if="!temps2Loading" class="temp-text text-center" style="text-align: center; padding:30px 0;">暂无相关数据</div>
                <div v-if="temps2Loading" class="temp-text loading text-center"><i class="el-icon-loading"></i></div>
              </div>
              
              
              
            </div>
            <div style="margin: 10px;" v-if="activeSideType=='images'">
              <upload-button
                type="success"
                @filesAdded="filesAdded"
                @progress="progress"
                @fileUploaded="fileUploaded"
              >上传图片</upload-button>
              <div style="text-align: right;color: #ccc; line-height: 50px;"> <!-- 容量: 49/100 --></div>
              <div :infinite-scroll-disabled="disabled" v-infinite-scroll="getImages" :style="{'height': mainHeight-100+'px', 'overflow-y': 'auto', 'overflow-x':'hidden', 'margin-top':'40px'}">
                <el-row :gutter="20">
                  <el-col v-for="(item, index) in uploadFiles" :key="index" :span="12">
                    <div class="imgbox" v-if="!item.imgurl" style="text-align: center;height: 160px; padding-top: 40px;">
                      <el-progress :width="60" type="circle" :percentage="item.percent"></el-progress>
                      <p>{{item.name}}</p>
                    </div>
                  </el-col>
                  <el-col v-for="(url, index) in images" :key="'img_'+index" :span="12">
                    <div class="imgbox" @click="inputimg(url)">
                      <el-image
                        style="height: 160px"
                        :src="url"
                        fit="contain"></el-image>
                    </div>
                  </el-col>
                </el-row>
                <div v-if="imgLoading" class="loading text-center temp-text"><i class="el-icon-loading"></i></div>
                <el-divider v-if="nomore&&images.length">没有更多了</el-divider>
                <div class="temp-text" style="text-align: center;" v-else-if="nomore&&!images.length">暂无图片，您可以上传图片。</div>
              </div>
            </div>
          </div>
        </div>
      </el-aside>
      <el-main :style="{height: mainHeight+'px',positions:'relative'}">
        
        
        <vue-ueditor-wrap @focus="editorClick" class="phonebox" @ready="ready" v-model="view" :config="myConfig"></vue-ueditor-wrap>
       
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import $http from "../../request.js";
import VueUeditorWrap from 'vue-ueditor-wrap';
import uploadButton from "../../components/uploadoss.vue";
// const baseUrl = "https://dev.qushanghui.com.cn";
const baseUrl = "";
export default {
  name:"home",
  components: {
    VueUeditorWrap,
    uploadButton
  },
  data(){
    return {
      wholeTmpName: "",
      collGroup: "", //当前显示的收藏组
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 500,
        enableAutoSave: false,
        // 初始容器宽度
        initialFrameWidth: "100%",
        initialStyle:'*{box-sizing: border-box;}img{max-width:100%;}',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/editor/UEditor/',
        allowDivTransToP: false,
        retainOnlyLabelPasted: false,
        elementPathEnabled: false,
        wordCount: false,
        autoFloatEnabled: true
      },
      selectImg: 0,
      imageInfo:{
        thumburl: "",
        title: "",
        desc: "",
        scoureurl: "",
        author: ""
      },
      views: [],
      view: "",
      mainHeight: 600,
      tags:[],
      activeTag: 0,
      temps: [],
      tempLoading: true,
      nomore: false,
      types:[{
        icon: "el-icon-tickets",
        name: "图文模板",
        active: "active",
        sidetype: "temp"
      },{
        icon: "el-icon-mobile",
        name: "完整模板",
        active: "",
        sidetype: "whole"
      },{
        icon: "el-icon-s-management",
        name: "图文收藏",
        active: "",
        sidetype: "collection"
      // },{
      //   icon: "el-icon-document-copy",
      //   name: "剪切板",
      //   active: "",
      //   sidetype: "shear"
      },{
        icon: "el-icon-picture",
        name: "我的图库",
        active: "",
        sidetype: "images"
      }],
      ue: null,
      activeSideType: this.$route.params.sidetype,
      uploadFiles: [],
      images: [],
      groupLoading: false,
      groups: [],
      collList: [],
      page: 1,
      activeTemp:{
        id:"",
        pid: ""
      },
      tempPage: 1,
      imgLoading: false,
      temps2: [],
      temps2Page: 1,
      temps2Loading: false,
      temps2NoMore: false,
      fullloading: null,
      saveloading: false,
      query: this.$route.query||{},
    };
  },
  computed:{
    disabled () {
      return this.imgLoading || this.nomore
    },
    disabled2(){
      return this.temps2Loading || this.temps2NoMore
    },
    perviewImgs(){
      let imgs = [];
      this.uploadFiles.forEach(v=>{
        if (v.imgurl) {
          imgs.push(v.imgurl);
        }
      });
      return [
        ...imgs
      ]
    }
  },
  watch:{
    // views(nVal){
    //   this.view = nVal.join('');
    // }
    activeSideType(nVal, oVal) {
      if(nVal!==oVal) {
        this.setSideTypeChecked(nVal);
      }
    },
    $route (nVal, oVal){
      if (nVal!==oVal) {
        this.activeSideType = nVal.params.sidetype;
        this.collectionList();
        this.getTemps();
        this.getImages();
      }
    },
    selectImg(nVal, oVal) {
      if(nVal!==oVal&&nVal===1) {
        this.$router.push({path:"images", query:{...this.$route.query}})
      }
    }
  },
  created(){

    window.onresize = ()=>{
      this.getWinHeight();
    }
    this.setSideTypeChecked(this.activeSideType);
    this.getGroup();
  },
  mounted(){
    this.getWinHeight();
    this.getTags().then(()=>{
      this.getTemps();
    });
    
    this.collectionList();
    this.getImages();
    this.getTemps2();
  },
  methods:{
    getImages(){
      if (this.$route.params.sidetype!=="images") return false;
      this.imgLoading = true;
      const params = 'page='+this.page+'&limit=10';
      this.page += 1;
      $http.get(baseUrl+"/general/attachment/editorSelect?"+params)
        .then(res=>{
          this.imgLoading = false;
          if (res.data.code===1) {
            if (res.data.data.rows.length===0) {
              this.nomore = true;
            } else {
              if (this.page===1) {
                this.images = [...res.data.data.rows.map(v=>v.url)];
              } else {
                this.images = [ ...this.images, ...res.data.data.rows.map(v=>v.url)];
              }
            }
          } else {
            this.nomore = true;
            this.$message.error("请求错误");
          }
        });
    },
    save(){
      window.parent.postMessage({ type: "fullEditor",data:this.view }, "*");
      // return
      // sessionStorage.setItem('isSave',true)
      // this.saveloading = true;
      // if (this.$route.query.time) {
      //   $http.post(baseUrl+"/ajax/dealTemp/action/save", {
      //     content:this.view
      //   })
      //     .then((res)=>{
      //       this.saveloading = false;
      //       if(res.data.code==1){
      //         localStorage.setItem('savetime', Date.now());
      //         this.$confirm('保存成功, 是否返回编辑页?', '提示', {
      //             confirmButtonText: '确定',
      //             cancelButtonText: '取消',
      //             type: 'success'
      //           }).then(() => {
      //             window.close()
      //           })
      //       }else {
      //         this.$message.error(res.msg);
      //       }
      //     })
      //     .catch(err=>{
      //       console.log(err);
      //       this.saveloading = false;
      //     })
      // } else if (this.$route.query.s) {
      //   $http.post(baseUrl+this.$route.query.s+'/action/save',{
      //     'row[content]':this.view
      //   })
      //     .then((res)=>{
      //       this.saveloading = false;
      //       if(res.data.code == 1){
      //         localStorage.setItem('savetime', Date.now());
      //         this.$confirm('保存成功, 是否返回编辑页?', '提示', {
      //             confirmButtonText: '确定',
      //             cancelButtonText: '取消',
      //             type: 'success'
      //           }).then(() => {
      //             window.close();
      //           })
      //       } else{
      //         this.$message.error(res.data.msg);
      //       }
            
      //     })
      //     .catch(err=>{
      //       console.log(err);
      //       this.saveloading = false;
      //     })
      // } else {
      //   this.saveloading = false;
      // }
    },
    recoveryTemp(){
      const temp = sessionStorage.getItem("editorContent");
      if (temp) {
        this.view = temp;
      }
    },
    dele_collection(id) {
      //collect_id
      console.log(id);
      this.$confirm('此操作将删除该收藏, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        $http.post(baseUrl+"/wxeditor/collect/del", {
          id
        })
          .then(res=>{
            if (res.data.code===1) {
              this.collList = this.collList.filter(v=>v.collect_id!=id);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // console.log(res.data.data.list);
            } else {
              this.$message.error("请求错误");
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    collectionList(){
      if (this.$route.params.sidetype!=="collection") return false;
      this.tempLoading = true;
      $http.post(baseUrl+"/wxeditor/collect") 
        .then(res=>{
          this.tempLoading = false;
          if (res.data.code===1) {
            this.collList = res.data.data.list;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    addCusTemp(){
      if (!this.view) {
        this.$message.error("模板编辑器内容不能为空");
        return false;
      }
      this.$prompt('请设置模板名称', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.oncollection('', value, this.view);
      });
      
    },
    oncollection(id, template_name, template_content){
      if(!template_content) template_content = "";
      if(!template_name) template_name = "";
      $http.post(baseUrl+"/wxeditor/collect/add", {
        template_id: id||"",
        group_id: 0,
        template_name,
        template_content
      }) 
        .then(res=>{
          if (res.data.code===1) {
            this.$message({
              message: '收藏成功',
              type: 'success'
            });
            this.temps = this.temps.map((v)=>{
              v.contextmenuVisited = false;
              return v;
            });
          } else {
            this.$message.error(res.data.msg||"标签请求错误");
          }
        });
    },
    contextmenuClick(){
      const tempBox = this.$refs.tempBox;
      const tempBox2 = this.$refs.tempBox2;
      
      //右键操作
      const tempDoms = tempBox&&tempBox.querySelectorAll('.temp-list-item');
      const tempDoms2 = tempBox2&&tempBox2.querySelectorAll('.temp-list-item');
      const _this = this;
      // const _this = this;
      function __contextmenu__ (e){
        // console.log(e);
        //窗口滚动距离
        // const tempBoxScrollTop = tempBox.scrollTop;
        const pointerX = e.pageX;
        const pointerY = e.pageY;
        // const oX = this.offsetLeft;
        // const oY = this.offsetTop;
        const contextmenuBox = this.nextElementSibling;
        const index = contextmenuBox.dataset.index;
        // console.log(_this.temps);
        contextmenuBox.onmouseleave = function(){
          _this.temps = _this.temps.map((v)=>{
            v.contextmenuVisited = false;
            return v;
          });
        };
        _this.temps = _this.temps.map((v, i)=>{
          if (i==index) {
            v.contextmenuVisited = true;
          } else {
            v.contextmenuVisited = false;
          }
          return v;
        });
        // console.log(tempBoxScrollTop, pointerX, pointerY, oX, oY);
        const x = pointerX;
        const y = pointerY;
        contextmenuBox.style.top = y-5+'px';
        contextmenuBox.style.left = x-5+'px';
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      tempBox&&tempDoms.forEach(function(o){
        // o.oncontextmenu = __contextmenu__;
        o.removeEventListener("contextmenu", __contextmenu__);
        o.addEventListener("contextmenu", __contextmenu__);
      });
      tempDoms2&&tempDoms2.forEach(function(o){
        // o.oncontextmenu = __contextmenu__;
        o.removeEventListener("contextmenu", __contextmenu__);
        o.addEventListener("contextmenu", __contextmenu__);
      });
    },
    collClick(e){
      //收藏组的点击事件
      console.log(e);
    },
    editorClick(e){
      console.log(e);
    },
    inputimg(url){
      if (!this.selectImg) return false;
      if (this.selectImg===1) {
        this.imageInfo.thumburl = url;
      } else if (this.selectImg.nodeName.toLocaleLowerCase()=='img') {
        this.selectImg.src = url;
        this.ue.execCommand('inserthtml', this.selectImg.outerHTML);
      } else if (this.selectImg.nodeName) {
        this.ue.execCommand('inserthtml', "<img src=\""+url+"\" width=\"100%\"/>");
      }
    },
    fileUploaded(payload){
      const file = payload.file;
      this.uploadFiles = this.uploadFiles.filter(v=>{
        return v.id!==file.id;
      })
      console.log(payload.url);
      this.images = [payload.url, ...this.images];
    },
    progress(payload){
      const file = payload.file;
      this.uploadFiles = this.uploadFiles.map(v=>{
        if(v.id===file.id) {
          v.percent = file.percent;
        }
        return v;
      });
    },
    filesAdded(payload){
      this.uploadFiles = payload.files;
    },
    setSideTypeChecked(sidetype) {
      this.types = this.types.map(v=>{
        if (v.sidetype===sidetype) {
          v.active = "active";
        } else {
          v.active = "";
        }
        return v;
      });
    },
    ready (editorInstance) {
      // console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
      const _this = this;
      this.ue = editorInstance;
      editorInstance.addListener('contentChange',function(){
          const imgs = editorInstance.body.getElementsByTagName('img');
          if(imgs&&imgs.length>0) {
            for (let i=0;i<imgs.length;i++){
              imgs[i].style.verticalAlign = 'middle';
              imgs[i].style['max-width'] =  '100% !important';
            }
          }
          _this.view = editorInstance.getContent();
       }) 
      editorInstance.body.onclick=function(e){
        _this.selectImg = e.target;
        if(e.target.nodeName.toLocaleLowerCase()=="img") {
          _this.$router.push({path:"images", query:{...this.$route.query}})
        }
      };
      _this.recoveryTemp();
    },
    checktype(index, id, pid){
      this.activeTag = index;
      this.activeTemp = {id, pid};
      this.tempPage = 1;
      this.temps = [];
      this.getTemps(id, pid);
    },
    selectTemp(index, temps){
      if (!temps) {
        temps = "temps";
      }
      this.views.push(this[temps][index].content);
      if (this.ue) {
        this.ue.execCommand('inserthtml', this[temps][index].content);
        this.view = this.ue.getContent();
      }
    },
    getWinHeight() {
      const h = document.documentElement.clientHeight||window.clientHeight;
      this.mainHeight = h -50;
    },
    getTags(){
      return new Promise((r,j)=>{
        $http.post(baseUrl+"/wxeditor/tag/index")
        .then(res=>{
          r(res);
          if (res.data.code===1) {
            this.tags = res.data.data;
          } else {
            this.$message.error("标签请求错误");
          }
        })
        .catch(err=>{
          j(err);
        });
      })
    },
    getTemps(id, pid){
      if (this.$route.params.sidetype!=="temp"||!this.tags||this.tags.length===0) return false;
      this.tempLoading = true;
      const params = {
        page: this.tempPage
      };
      this.tempPage += 1;
      const defaultTag = this.tags.find((v,i)=>i==this.activeTag);
      const tag_id = id||(this.activeTemp&&this.activeTemp.id)||defaultTag.id;
      const parent_id = pid||(this.activeTemp&&this.activeTemp.pid)||defaultTag.parent_id;
      if (parent_id>0) {
        params.tag_id = tag_id;
        delete params.parent_id;
      } else {
        params.parent_id = tag_id;
        delete params.tag_id;
      }
      $http.post(baseUrl+"/wxeditor/template/search", params) 
        .then(res=>{
          this.tempLoading = false;
          if (res.data.code===1) {
            if (params.page==1) {
              this.temps = res.data.data.list;
            } else if (params.page>1) {
              if(res.data.data.list.length>0) {
                this.temps = [...this.temps,...res.data.data.list];
              }
            }
            setTimeout(()=>{
              this.contextmenuClick();
            }, 200);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getTemps2(source){
      if (source=='event') {
        this.temps2Page = 1;
        this.temps2 = [];
      }
      const params = {
        page: this.temps2Page,
        template_type: 2,
        tag_name: this.wholeTmpName
      }
      this.temps2Page++;
      this.temps2Loading = true;
      $http.post(baseUrl+"/wxeditor/template/search", params) 
        .then(res=>{
          this.temps2Loading = false;
          if (res.data.code===1) {
            if (params.page==1) {
              this.temps2 = res.data.data.list;
            } else if (params.page>1) {
              if(res.data.data.list.length>0) {
                this.temps2 = [...this.temps2,...res.data.data.list];
              } else {
                this.temps2NoMore = true;
              }
            }
            setTimeout(()=>{
              this.contextmenuClick();
            }, 200);
          } else {
            this.temps2NoMore = true;
            this.$message.error(res.data.msg);
          }
        });
    },
    getGroup(){
      this.groupLoading = true;
      $http.post(baseUrl+"/wxeditor/template_collect_group/index", {
        page: 1,
        size: 10
      }) 
        .then(res=>{
          this.groupLoading = false;
          if (res.data.code===1) {
            this.groups = res.data.data.list;
            if (this.groups[0]) {
              this.collGroup = this.groups[0].id.toString();
            }
          }
          // if (res.data.total||res.data.total===0) {
          //   this.temps = res.data.list;
          // } else {
          //   this.$message.error("标签请求错误");
          // }
        });
    }
  }
};
</script>

<style lang="less" scoped>
  /deep/.el-card.is-always-shadow,
  /deep/.el-card.is-hover-shadow:focus,
  /deep/.el-card.is-hover-shadow:hover{
    box-shadow: 0 0 8px #60d0ff;
  }
  .toolbox {
    position: fixed;
    top:100px;
    right:50%;
    margin-right: -570px;
    width: 100px;
  }
  .coll-name {
    position: absolute;
    font-size: 16px;
    z-index: 100;
    height: 30px;
    line-height: 30px;
    left:5px;
    top: 5px;
    padding:0 15px;
    color: #d3d3d3;
    background-color: #424a58;
    border-radius: 15px;
  }
  .dele_collection {
    position: absolute;
    font-size: 24px;
    z-index: 100;
    top: -5px;
    right:10px;
  }
  .contextmenu-box {
    position: absolute;
    z-index: 100;
  }
  .temp-text  {
    color: #d3d3d3;
  }
  .loading {
    font-size: 32px;
    text-align: center;
    padding-top: 50px;
  }
  /deep/ .el-col {
    margin-bottom: 20px;
  }
  .imgbox{
    width: 100%;
    height: 160px;
    background-color: #f1f1f1;
    border-radius: 4px;
    transition: .3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 8px #60d0ff;
    }
  }
  .thumburl {
    border: 1px transparent dashed;
    background-color: #eee;
    font-size: 14px;
    color: #666;
    &.active{
      box-sizing: border-box;
      border: 1px #999 dashed;
    }
    &:active {
      background-color: rgba(0,0,0, .5);
    }
  }
  .main-box {
    width: 416px;
    margin: 30px auto;
    background-color: #fff;
    font-size: 16px;
    line-height:1.6;
    box-shadow: 0 0 8px #ccc;
    border-radius: 4px;
    padding: 15px;
  }
  .menu-child {
    list-style: none;
    margin:0;
    padding:10px 0;
    background-color: rgb(103, 101, 103);
    overflow: hidden;
    width: 100px;
    border-radius: 4px;
    display: none;
    .menu-list-item {
      width: 100px !important;
      height: 30px !important;
      line-height: 30px;
      text-align: left;
      text-indent: 20px;
      border: none;
      &:hover{
        background-color: rgba(245, 245, 245, .3);
      }
      &:focus{
        background-color: #60d0ff;
      }
    }
  }
  .menu-list {
    width: 400px;
    position: relative;
    z-index: 100;
  }
  .temp-list {
    width: 400px;
    box-sizing: border-box;
    height: 600px;
    margin:auto;
    padding:0 12.5px;
    overflow: auto;
    .temp-list-item {
      cursor: pointer;
      background-color: #fff;
      padding: 10px;
      margin: 8px;
      transition: .3s;
      max-height: 600px;
      overflow: hidden;
      &:hover {
        box-shadow: 0 0 8px #60d0ff;
        transform: translateY(-2px);
      }
    }
  }
  .menu-list-item {
    float: left;
    width: 57px;
    height: 35px;
    color: #eee;
    text-decoration: none;
    text-align: center;
    line-height: 35px;
    font-size: 14px;
    border-bottom: 2px solid transparent;
    &:last-child {
      .menu-child {
        margin-left: -43px;
      }
    }
    &:hover {
      color: #fff;
      background-color: rgb(103, 101, 103);
      border-color: #60d0ff;
      .menu-child {
        display: block;
      }
    }
    &.active {
      border-color: #eee;
    }
  }
  .navbar{
    height: 50px;
    background: url(../../assets/img/navbar-bg.jpg) center;
    margin:0 -20px;
    box-shadow: 0 0 10px rgba(0,0,0,.2);
  }
  .sidebar{
    background-color: #424a58;
    height: 100%;
    width: 100%;
    // color: #d3d3d3;
    /deep/.el-tabs__item {
      color: #d3d3d3;
      &:hover {
        color: #fff;
      }
    }
    .right-content {
      width: 400px;
      height: 100%;
    }
    .left-tab {
      background-color: #282d36;
      width: 100px;
      height: 100%;
    }
    .left-tab-item {
      text-align: center;
      width:100px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      margin-bottom: 2px;
      &:hover {
        a {
          transform: translateY(-5px);
        }
      }
      &.active, &:active{
        background-color: #424a58;
        a {
          color: #fff;
          transform: translateY(0);
        }
      }
      i {
        font-size: 32px;
      }
      a {
        display: block;
        width: 100%;
        padding: 15px 0;
        transition: .3s;
        color: #d3d3d3;
        text-decoration: none;
      }
      
    }
  }
  .phonebox {
    width: 468px;
    margin:auto;
    background-color: #fff;
    font-size: 16px;
    line-height:1.6;
    box-shadow: 0 0 8px #ccc;
    border-radius: 4px;
  }
  .input-box {
    width: 375px;
    border: 1px dashed #999;
    margin:10px auto;
    font-size: 12px;
    line-height:1.6;
    outline: none;
    transition: 1s;
    padding: 5px;
    &:focus{
      box-shadow: 0 0 5px skyblue;
    }
    &:hover{
      border-color: #666;
    }
  }
  .text-desc {
    font-size: 14px;
    color: #999;
    width: 375px;
    margin:auto;
  }
</style>
